// Quiz questions for each level - PCEP aligned
export const quizQuestions = {
  1: [
    {
      question: "What does the print() function do in Python?",
      options: [
        "Saves text to a file",
        "Displays output to the console/screen",
        "Creates a new variable",
        "Deletes a variable"
      ],
      correctAnswer: 1,
      explanation: "print() displays text or values to the console output where users can see it."
    },
    {
      question: "Which of these is a correct way to print 'Hello, World!' in Python?",
      options: [
        "print('Hello, World!')",
        "Print('Hello, World!')",
        "PRINT('Hello, World!')",
        "echo('Hello, World!')"
      ],
      correctAnswer: 0,
      explanation: "Python is case-sensitive, so print() must be lowercase. Print() and PRINT() won't work."
    },
    {
      question: "What happens if you use double quotes instead of single quotes for a string?",
      options: [
        "Python will show an error",
        "The string will be different",
        "It works the same way",
        "The program will crash"
      ],
      correctAnswer: 2,
      explanation: "In Python, single quotes (' ') and double quotes (\" \") work identically for strings."
    },
    {
      question: "What is a 'string' in Python?",
      options: [
        "A number",
        "A piece of text",
        "A function",
        "A loop"
      ],
      correctAnswer: 1,
      explanation: "A string is text data - any sequence of characters enclosed in quotes."
    },
    {
      question: "Is Python case-sensitive?",
      options: [
        "Yes, print() and Print() are different",
        "No, they are treated the same",
        "Only for variables",
        "Only for functions"
      ],
      correctAnswer: 0,
      explanation: "Python is case-sensitive everywhere - function names, variable names, keywords, etc."
    }
  ],

  2: [
    {
      question: "Which is a valid variable name in Python?",
      options: [
        "2name",
        "user-name",
        "user_name",
        "user name"
      ],
      correctAnswer: 2,
      explanation: "Variable names can't start with numbers, contain hyphens or spaces. user_name follows Python naming conventions."
    },
    {
      question: "What naming convention does Python recommend for variables?",
      options: [
        "camelCase",
        "PascalCase",
        "snake_case",
        "kebab-case"
      ],
      correctAnswer: 2,
      explanation: "PEP 8 recommends snake_case (lowercase with underscores) for variable names."
    },
    {
      question: "What is stored in a variable?",
      options: [
        "Only numbers",
        "Only text",
        "Data values of any type",
        "Only True or False"
      ],
      correctAnswer: 2,
      explanation: "Variables can store any type of data - numbers, text, boolean values, lists, etc."
    },
    {
      question: "Can you change a variable's value after creating it?",
      options: [
        "No, variables are permanent",
        "Yes, you can reassign new values",
        "Only if it's a number",
        "Only once"
      ],
      correctAnswer: 1,
      explanation: "Variables can be reassigned any number of times with new values."
    },
    {
      question: "What symbol is used to assign a value to a variable?",
      options: [
        ":",
        "==",
        "=",
        "->"
      ],
      correctAnswer: 2,
      explanation: "The single equals sign (=) is the assignment operator in Python."
    }
  ],

  3: [
    {
      question: "What is the data type of 42 in Python?",
      options: [
        "str",
        "int",
        "float",
        "bool"
      ],
      correctAnswer: 1,
      explanation: "42 is an integer (whole number), so its type is int."
    },
    {
      question: "What function tells you the type of a value?",
      options: [
        "typeof()",
        "type()",
        "getType()",
        "datatype()"
      ],
      correctAnswer: 1,
      explanation: "type() is the built-in function that returns the data type of any value."
    },
    {
      question: "What is the data type of 'Hello'?",
      options: [
        "int",
        "text",
        "str",
        "string"
      ],
      correctAnswer: 2,
      explanation: "'Hello' is a string, and Python's string type is called 'str'."
    },
    {
      question: "Does Python require you to declare variable types?",
      options: [
        "Yes, you must always declare types",
        "No, Python determines types automatically",
        "Only for numbers",
        "Only for strings"
      ],
      correctAnswer: 1,
      explanation: "Python uses dynamic typing - it automatically determines the type based on the value assigned."
    },
    {
      question: "What does type(True) return?",
      options: [
        "<class 'int'>",
        "<class 'str'>",
        "<class 'bool'>",
        "<class 'boolean'>"
      ],
      correctAnswer: 2,
      explanation: "True is a boolean value, so its type is 'bool' (not 'boolean')."
    }
  ],

  4: [
    {
      question: "What is the result of 10 + 5 * 2?",
      options: [
        "30",
        "20",
        "15",
        "25"
      ],
      correctAnswer: 1,
      explanation: "Following order of operations (PEMDAS), multiplication happens first: 5 * 2 = 10, then 10 + 10 = 20."
    },
    {
      question: "What operator gives the remainder of division?",
      options: [
        "/",
        "//",
        "%",
        "^"
      ],
      correctAnswer: 2,
      explanation: "The modulo operator (%) returns the remainder. For example, 10 % 3 = 1."
    },
    {
      question: "What is 2 ** 3 in Python?",
      options: [
        "6",
        "8",
        "9",
        "5"
      ],
      correctAnswer: 1,
      explanation: "** is the exponentiation operator. 2 ** 3 = 2³ = 8."
    },
    {
      question: "How do you force addition before multiplication?",
      options: [
        "Use the + operator twice",
        "Use parentheses: (10 + 5) * 2",
        "Python automatically does addition first",
        "It's not possible"
      ],
      correctAnswer: 1,
      explanation: "Parentheses override normal operator precedence, forcing operations inside to execute first."
    },
    {
      question: "What is floor division (//) used for?",
      options: [
        "Regular division",
        "Division that returns a float",
        "Division that returns only the whole number part",
        "Modulo operation"
      ],
      correctAnswer: 2,
      explanation: "Floor division (//) divides and rounds down to the nearest integer. 10 // 3 = 3 (not 3.333...)."
    }
  ],

  5: [
    {
      question: "How do you join two strings in Python?",
      options: [
        "string1 - string2",
        "string1 + string2",
        "string1 & string2",
        "join(string1, string2)"
      ],
      correctAnswer: 1,
      explanation: "The + operator concatenates (joins) strings together."
    },
    {
      question: "What is an f-string in Python?",
      options: [
        "A function string",
        "A formatted string literal that can include variables",
        "A fixed string that cannot change",
        "A file string"
      ],
      correctAnswer: 1,
      explanation: "F-strings (f'...{variable}...') allow you to embed expressions inside string literals."
    },
    {
      question: "Which is the modern way to format strings in Python 3.6+?",
      options: [
        "% formatting",
        ".format() method",
        "f-strings",
        "String concatenation"
      ],
      correctAnswer: 2,
      explanation: "F-strings (formatted string literals) are the recommended modern approach for string formatting."
    },
    {
      question: "Can strings be changed after creation?",
      options: [
        "Yes, strings are mutable",
        "No, strings are immutable",
        "Only if using single quotes",
        "Only numeric strings"
      ],
      correctAnswer: 1,
      explanation: "Strings are immutable in Python - once created, they cannot be modified. Methods return new strings."
    },
    {
      question: "What does 'Hello' * 3 produce?",
      options: [
        "HelloHelloHello",
        "Hello3",
        "Error",
        "3Hello"
      ],
      correctAnswer: 0,
      explanation: "The * operator repeats strings. 'Hello' * 3 = 'HelloHelloHello'."
    }
  ],

  6: [
    {
      question: "What does the input() function return in Python?",
      options: [
        "An integer",
        "A string",
        "A float",
        "A boolean"
      ],
      correctAnswer: 1,
      explanation: "input() always returns a string, even if the user types a number. Use int() or float() to convert if needed."
    },
    {
      question: "How do you convert user input to an integer?",
      options: [
        "integer(input())",
        "int(input())",
        "toInt(input())",
        "input().int()"
      ],
      correctAnswer: 1,
      explanation: "int() is the built-in function that converts a string to an integer."
    },
    {
      question: "What happens if input() is called without a prompt?",
      options: [
        "Python shows an error",
        "The program waits for input with no message",
        "It returns an empty string",
        "It returns None"
      ],
      correctAnswer: 1,
      explanation: "input() can be called without arguments - it will wait for user input but display no prompt message."
    },
    {
      question: "What is the correct syntax for input() with a prompt?",
      options: [
        "input(prompt='Enter name: ')",
        "input('Enter name: ')",
        "input.prompt('Enter name: ')",
        "prompt('Enter name: ')"
      ],
      correctAnswer: 1,
      explanation: "The prompt string is passed directly as an argument: input('prompt message')"
    },
    {
      question: "How do you read multiple inputs in one line?",
      options: [
        "Call input() multiple times",
        "Use input().split()",
        "Use multi_input()",
        "Both A and B are valid approaches"
      ],
      correctAnswer: 3,
      explanation: "You can call input() multiple times for separate prompts, or use input().split() to get multiple values from one line."
    }
  ],

  7: [
    {
      question: "What is the correct syntax for an if statement in Python?",
      options: [
        "if (x > 5) { }",
        "if x > 5:",
        "if x > 5 then:",
        "if (x > 5):"
      ],
      correctAnswer: 1,
      explanation: "Python uses 'if condition:' with a colon and no parentheses required (though they're allowed)."
    },
    {
      question: "What operator checks if two values are equal?",
      options: [
        "=",
        "==",
        "equals",
        "is"
      ],
      correctAnswer: 1,
      explanation: "== is the equality comparison operator. = is assignment, and 'is' checks identity (same object)."
    },
    {
      question: "What does the 'elif' keyword stand for?",
      options: [
        "Else if",
        "Else conditional",
        "Elif condition",
        "End if"
      ],
      correctAnswer: 0,
      explanation: "'elif' is short for 'else if' - it allows you to check multiple conditions in sequence."
    },
    {
      question: "How do you check if a number is even?",
      options: [
        "num % 2 == 0",
        "num / 2 == 0",
        "num.isEven()",
        "even(num)"
      ],
      correctAnswer: 0,
      explanation: "The modulo operator (%) returns the remainder. If num % 2 equals 0, the number is even."
    },
    {
      question: "What is the purpose of the 'else' block?",
      options: [
        "To check another condition",
        "To execute when all previous conditions are False",
        "To end the if statement",
        "To handle errors"
      ],
      correctAnswer: 1,
      explanation: "'else' executes when the if condition (and any elif conditions) evaluate to False."
    }
  ],

  8: [
    {
      question: "What does range(5) generate?",
      options: [
        "Numbers 1 to 5",
        "Numbers 0 to 5",
        "Numbers 0 to 4",
        "Numbers 1 to 4"
      ],
      correctAnswer: 2,
      explanation: "range(5) generates numbers from 0 up to (but not including) 5: 0, 1, 2, 3, 4."
    },
    {
      question: "How do you iterate over a list in Python?",
      options: [
        "for item in list:",
        "foreach item in list:",
        "for (item : list):",
        "loop item in list:"
      ],
      correctAnswer: 0,
      explanation: "Python uses 'for item in sequence:' syntax to iterate over any iterable object."
    },
    {
      question: "What does range(1, 10, 2) produce?",
      options: [
        "1, 2, 3, 4, 5, 6, 7, 8, 9",
        "1, 3, 5, 7, 9",
        "2, 4, 6, 8, 10",
        "1, 2, 10"
      ],
      correctAnswer: 1,
      explanation: "range(start, stop, step) with step=2 generates odd numbers: 1, 3, 5, 7, 9."
    },
    {
      question: "Can you modify a list while iterating over it with a for loop?",
      options: [
        "Yes, always safe",
        "No, it's not recommended as it can cause errors",
        "Only if using range()",
        "Only in Python 3"
      ],
      correctAnswer: 1,
      explanation: "Modifying a list during iteration can cause unexpected behavior. Create a copy or use list comprehension instead."
    },
    {
      question: "What happens when you iterate over an empty list?",
      options: [
        "Python shows an error",
        "The loop body never executes",
        "It loops once with None",
        "The program crashes"
      ],
      correctAnswer: 1,
      explanation: "Iterating over an empty sequence simply skips the loop body entirely - no error occurs."
    }
  ],

  9: [
    {
      question: "What is the main difference between while and for loops?",
      options: [
        "while is faster",
        "while continues while a condition is True, for iterates over sequences",
        "for can run forever, while cannot",
        "They are exactly the same"
      ],
      correctAnswer: 1,
      explanation: "while loops run as long as a condition is True; for loops iterate over a fixed sequence."
    },
    {
      question: "What is an infinite loop?",
      options: [
        "A loop that runs very fast",
        "A loop that never terminates",
        "A loop with no body",
        "A loop that runs exactly once"
      ],
      correctAnswer: 1,
      explanation: "An infinite loop occurs when the loop condition never becomes False, causing the loop to run forever."
    },
    {
      question: "How do you exit a while loop early?",
      options: [
        "Use the 'exit' keyword",
        "Use the 'break' keyword",
        "Use the 'stop' keyword",
        "Use the 'return' keyword"
      ],
      correctAnswer: 1,
      explanation: "The 'break' keyword immediately exits the current loop."
    },
    {
      question: "What does the 'continue' keyword do in a loop?",
      options: [
        "Exits the loop",
        "Skips to the next iteration",
        "Pauses the loop",
        "Restarts the loop from the beginning"
      ],
      correctAnswer: 1,
      explanation: "'continue' skips the rest of the current iteration and moves to the next one."
    },
    {
      question: "Why must you update the loop variable in a while loop?",
      options: [
        "To make the code look better",
        "To eventually make the condition False and exit the loop",
        "Python requires it",
        "It's not necessary"
      ],
      correctAnswer: 1,
      explanation: "Without updating the loop variable, the condition may never become False, creating an infinite loop."
    }
  ],

  10: [
    {
      question: "How do you create an empty list in Python?",
      options: [
        "list = empty()",
        "list = []",
        "list = new List()",
        "list = ()"
      ],
      correctAnswer: 1,
      explanation: "[] creates an empty list. () creates a tuple, and list() also works."
    },
    {
      question: "What does list indexing start at in Python?",
      options: [
        "1",
        "0",
        "-1",
        "It depends on the list"
      ],
      correctAnswer: 1,
      explanation: "Python uses zero-based indexing - the first element is at index 0."
    },
    {
      question: "How do you add an item to the end of a list?",
      options: [
        "list.add(item)",
        "list.append(item)",
        "list.push(item)",
        "list.insert(item)"
      ],
      correctAnswer: 1,
      explanation: "The append() method adds an item to the end of a list."
    },
    {
      question: "What does negative indexing do in Python lists?",
      options: [
        "Causes an error",
        "Accesses elements from the end (list[-1] is the last element)",
        "Removes elements",
        "Creates a new list"
      ],
      correctAnswer: 1,
      explanation: "Negative indices count from the end: -1 is the last element, -2 is second-to-last, etc."
    },
    {
      question: "Can lists contain different data types?",
      options: [
        "No, all elements must be the same type",
        "Yes, Python lists can contain mixed types",
        "Only numbers and strings",
        "Only in Python 3"
      ],
      correctAnswer: 1,
      explanation: "Python lists are heterogeneous - they can contain elements of different types in the same list."
    }
  ],

  11: [
    {
      question: "What keyword is used to define a function in Python?",
      options: [
        "function",
        "def",
        "func",
        "define"
      ],
      correctAnswer: 1,
      explanation: "The 'def' keyword is used to define functions in Python."
    },
    {
      question: "What does the 'return' statement do?",
      options: [
        "Prints a value",
        "Ends the function and optionally sends a value back to the caller",
        "Starts the function",
        "Creates a variable"
      ],
      correctAnswer: 1,
      explanation: "'return' exits the function and optionally sends a value back to where the function was called."
    },
    {
      question: "What happens if a function has no return statement?",
      options: [
        "Python shows an error",
        "The function returns None",
        "The function returns 0",
        "The function returns an empty string"
      ],
      correctAnswer: 1,
      explanation: "If no return statement is present, Python automatically returns None."
    },
    {
      question: "Can a function have multiple return statements?",
      options: [
        "No, only one return allowed",
        "Yes, but only the first one reached will execute",
        "Yes, all returns execute",
        "Only in Python 3"
      ],
      correctAnswer: 1,
      explanation: "A function can have multiple return statements, but only the first one reached during execution will run."
    },
    {
      question: "What are function parameters?",
      options: [
        "The values returned by the function",
        "Variables that receive values when the function is called",
        "The function name",
        "The function's output"
      ],
      correctAnswer: 1,
      explanation: "Parameters are variables listed in the function definition that receive values (arguments) when the function is called."
    }
  ],

  12: [
    {
      question: "How do you create an empty dictionary in Python?",
      options: [
        "dict = []",
        "dict = {}",
        "dict = ()",
        "dict = <>"
      ],
      correctAnswer: 1,
      explanation: "{} creates an empty dictionary. dict() also works."
    },
    {
      question: "How do you access a value in a dictionary?",
      options: [
        "dict[key]",
        "dict.key",
        "dict(key)",
        "dict->key"
      ],
      correctAnswer: 0,
      explanation: "Use square brackets with the key: dict[key] to access the corresponding value."
    },
    {
      question: "What happens if you try to access a key that doesn't exist?",
      options: [
        "Returns None",
        "Raises a KeyError",
        "Returns an empty string",
        "Creates the key"
      ],
      correctAnswer: 1,
      explanation: "Accessing a non-existent key raises a KeyError. Use .get() method for safe access."
    },
    {
      question: "Can dictionary keys be of any data type?",
      options: [
        "Yes, any type",
        "No, keys must be immutable (strings, numbers, tuples)",
        "Only strings",
        "Only integers"
      ],
      correctAnswer: 1,
      explanation: "Dictionary keys must be immutable types: strings, numbers, tuples (but not lists or dicts)."
    },
    {
      question: "How do you add a new key-value pair to a dictionary?",
      options: [
        "dict.add(key, value)",
        "dict[key] = value",
        "dict.insert(key, value)",
        "dict.append(key, value)"
      ],
      correctAnswer: 1,
      explanation: "Simply assign a value to a new key: dict[key] = value to add or update entries."
    }
  ],

  13: [
    {
      question: "What is a list comprehension?",
      options: [
        "A way to understand lists",
        "A concise way to create lists using a single line of code",
        "A list method",
        "A type of loop"
      ],
      correctAnswer: 1,
      explanation: "List comprehensions provide a concise syntax to create lists: [expression for item in iterable]."
    },
    {
      question: "What is the result of [x * 2 for x in range(3)]?",
      options: [
        "[0, 1, 2]",
        "[0, 2, 4]",
        "[2, 4, 6]",
        "[1, 2, 3]"
      ],
      correctAnswer: 1,
      explanation: "This doubles each number in range(3), which is 0, 1, 2: result is [0, 2, 4]."
    },
    {
      question: "Can you add conditions to list comprehensions?",
      options: [
        "No, conditions are not allowed",
        "Yes, using if at the end: [x for x in list if condition]",
        "Only with elif",
        "Only with while"
      ],
      correctAnswer: 1,
      explanation: "You can filter items using if: [x for x in iterable if condition]."
    },
    {
      question: "What's the equivalent of [x for x in range(5)] using a regular loop?",
      options: [
        "A for loop that appends x to a list",
        "A while loop",
        "A map function",
        "Cannot be done with loops"
      ],
      correctAnswer: 0,
      explanation: "List comprehensions are shorthand for creating lists with for loops and append()."
    },
    {
      question: "Are list comprehensions generally faster than regular loops?",
      options: [
        "No, they're slower",
        "Yes, they're usually faster and more Pythonic",
        "They're exactly the same speed",
        "Only in Python 2"
      ],
      correctAnswer: 1,
      explanation: "List comprehensions are optimized in Python and are generally faster than equivalent for loops."
    }
  ],

  14: [
    {
      question: "How do you import a module in Python?",
      options: [
        "include module",
        "import module",
        "using module",
        "require module"
      ],
      correctAnswer: 1,
      explanation: "Use the 'import' keyword: import module_name to import a module."
    },
    {
      question: "What is the difference between 'import math' and 'from math import sqrt'?",
      options: [
        "No difference",
        "'import math' imports everything, needs math.sqrt(); 'from math import sqrt' imports just sqrt",
        "'from math' is not valid syntax",
        "'import math' is faster"
      ],
      correctAnswer: 1,
      explanation: "'import math' requires 'math.sqrt()' to use sqrt. 'from math import sqrt' allows direct 'sqrt()' usage."
    },
    {
      question: "What does 'import math as m' do?",
      options: [
        "Creates an error",
        "Imports math module and allows you to use 'm' as an alias",
        "Imports only the 'm' function from math",
        "Imports math twice"
      ],
      correctAnswer: 1,
      explanation: "The 'as' keyword creates an alias. You can then use 'm.sqrt()' instead of 'math.sqrt()'."
    },
    {
      question: "Which module is part of Python's standard library?",
      options: [
        "numpy",
        "pandas",
        "random",
        "flask"
      ],
      correctAnswer: 2,
      explanation: "random is part of Python's standard library. numpy, pandas, and flask must be installed separately."
    },
    {
      question: "What does the 'dir()' function do when passed a module?",
      options: [
        "Deletes the module",
        "Shows all attributes and functions in the module",
        "Imports the module",
        "Creates a directory"
      ],
      correctAnswer: 1,
      explanation: "dir(module) returns a list of all names (attributes and functions) defined in the module."
    }
  ],

  15: [
    {
      question: "What does int() do when converting a string?",
      options: [
        "Always returns 0",
        "Converts the string to an integer if it contains a valid number",
        "Converts to float first",
        "Removes all numbers"
      ],
      correctAnswer: 1,
      explanation: "int() converts a string containing a valid integer to an int type. Raises ValueError if invalid."
    },
    {
      question: "What happens if you try int('3.14')?",
      options: [
        "Returns 3",
        "Raises a ValueError",
        "Returns 3.14",
        "Returns 4"
      ],
      correctAnswer: 1,
      explanation: "int() cannot directly convert decimal strings. Use float() first: int(float('3.14'))."
    },
    {
      question: "In a calculator program, why validate user input?",
      options: [
        "It's not necessary",
        "To prevent errors from invalid data (non-numeric strings, division by zero, etc.)",
        "To make the code longer",
        "Only for decoration"
      ],
      correctAnswer: 1,
      explanation: "Input validation prevents crashes from invalid input like non-numeric strings or division by zero."
    },
    {
      question: "Which operator performs regular division in Python 3?",
      options: [
        "//",
        "/",
        "%",
        "div"
      ],
      correctAnswer: 1,
      explanation: "/ performs float division (returns decimal). // performs floor division (returns integer)."
    },
    {
      question: "What's a good practice when building interactive programs?",
      options: [
        "Never show error messages",
        "Provide clear prompts and handle errors gracefully",
        "Crash on invalid input",
        "Ignore user input"
      ],
      correctAnswer: 1,
      explanation: "Good programs have clear prompts, validate input, and handle errors with helpful messages."
    }
  ],

  16: [
    {
      question: "What is the main difference between a tuple and a list?",
      options: [
        "Tuples use () and are immutable; lists use [] and are mutable",
        "Tuples are faster but otherwise identical",
        "Tuples can only contain numbers",
        "There is no difference"
      ],
      correctAnswer: 0,
      explanation: "Tuples are immutable (cannot be changed after creation) and use parentheses. Lists are mutable and use brackets."
    },
    {
      question: "Can you change a tuple after creating it?",
      options: [
        "Yes, using tuple.append()",
        "No, tuples are immutable",
        "Yes, using tuple[0] = value",
        "Only in Python 3"
      ],
      correctAnswer: 1,
      explanation: "Tuples are immutable - once created, they cannot be modified, added to, or removed from."
    },
    {
      question: "How do you create a tuple with a single element?",
      options: [
        "(element)",
        "(element,)",
        "[element]",
        "{element}"
      ],
      correctAnswer: 1,
      explanation: "Use a trailing comma: (element,) to create a single-element tuple. (element) is just a parenthesized expression."
    },
    {
      question: "Can you use indexing on tuples?",
      options: [
        "No, only on lists",
        "Yes, tuples support indexing like lists",
        "Only positive indices",
        "Only with strings"
      ],
      correctAnswer: 1,
      explanation: "Tuples support indexing and slicing just like lists, even though they're immutable."
    },
    {
      question: "Why would you use a tuple instead of a list?",
      options: [
        "Tuples are slower",
        "When you want data that shouldn't change (immutability), tuples are more memory-efficient",
        "Tuples can store more data",
        "Lists are deprecated"
      ],
      correctAnswer: 1,
      explanation: "Tuples are used for data that shouldn't change. They're more memory-efficient and can be used as dictionary keys."
    }
  ],

  17: [
    {
      question: "What is a key characteristic of sets?",
      options: [
        "They allow duplicate elements",
        "They contain only unique elements (no duplicates)",
        "They are ordered",
        "They can only contain numbers"
      ],
      correctAnswer: 1,
      explanation: "Sets automatically remove duplicates - each element appears only once."
    },
    {
      question: "Are sets ordered in Python?",
      options: [
        "Yes, always ordered",
        "No, sets are unordered (order is not guaranteed)",
        "Only if created with sorted()",
        "Only in Python 3.7+"
      ],
      correctAnswer: 1,
      explanation: "Sets are unordered collections - elements have no guaranteed order (though Python 3.7+ maintains insertion order)."
    },
    {
      question: "How do you add an element to a set?",
      options: [
        "set.append(element)",
        "set.add(element)",
        "set.insert(element)",
        "set.push(element)"
      ],
      correctAnswer: 1,
      explanation: "Use the add() method to add a single element to a set."
    },
    {
      question: "What happens if you add an element that already exists in a set?",
      options: [
        "Raises an error",
        "The set remains unchanged (duplicates are ignored)",
        "Creates a duplicate",
        "Removes the old element"
      ],
      correctAnswer: 1,
      explanation: "Sets automatically ignore duplicates - adding an existing element has no effect."
    },
    {
      question: "Which operation finds common elements between two sets?",
      options: [
        "set1.union(set2)",
        "set1.intersection(set2)",
        "set1.difference(set2)",
        "set1.combine(set2)"
      ],
      correctAnswer: 1,
      explanation: "intersection() returns a new set with elements common to both sets. Can also use & operator."
    }
  ],

  18: [
    {
      question: "What does the upper() method do?",
      options: [
        "Capitalizes only the first letter",
        "Converts all characters to uppercase",
        "Increases the string length",
        "Removes uppercase letters"
      ],
      correctAnswer: 1,
      explanation: "upper() returns a new string with all characters converted to uppercase."
    },
    {
      question: "What does 'hello'.replace('l', 'L') return?",
      options: [
        "'heLLo'",
        "'Hello'",
        "'heLlo'",
        "'HELLO'"
      ],
      correctAnswer: 0,
      explanation: "replace() replaces all occurrences: 'hello' becomes 'heLLo'."
    },
    {
      question: "Does calling string.upper() modify the original string?",
      options: [
        "Yes, strings are mutable",
        "No, strings are immutable; it returns a new string",
        "Only in Python 3",
        "Only if assigned back"
      ],
      correctAnswer: 1,
      explanation: "Strings are immutable. Methods like upper() return new strings without modifying the original."
    },
    {
      question: "What does the strip() method do?",
      options: [
        "Removes all characters",
        "Removes leading and trailing whitespace",
        "Removes all vowels",
        "Makes the string shorter"
      ],
      correctAnswer: 1,
      explanation: "strip() removes whitespace (spaces, tabs, newlines) from the beginning and end of a string."
    },
    {
      question: "How do you split a string into a list of words?",
      options: [
        "string.split()",
        "string.divide()",
        "string.toList()",
        "list(string)"
      ],
      correctAnswer: 0,
      explanation: "split() divides a string into a list of substrings. By default, it splits on whitespace."
    }
  ],

  19: [
    {
      question: "What is slicing in Python?",
      options: [
        "Deleting elements",
        "Extracting a portion of a sequence using [start:stop:step]",
        "Cutting strings",
        "A type of loop"
      ],
      correctAnswer: 1,
      explanation: "Slicing extracts a portion of a sequence using the syntax [start:stop:step]."
    },
    {
      question: "What does list[2:5] return?",
      options: [
        "Elements at indices 2, 3, 4",
        "Elements at indices 2, 3, 4, 5",
        "Elements at indices 3, 4, 5",
        "Elements at indices 2, 5"
      ],
      correctAnswer: 0,
      explanation: "Slicing [start:stop] includes start but excludes stop. [2:5] returns indices 2, 3, 4."
    },
    {
      question: "What does list[:3] mean?",
      options: [
        "All elements",
        "First three elements (indices 0, 1, 2)",
        "Last three elements",
        "Every third element"
      ],
      correctAnswer: 1,
      explanation: "Omitting start defaults to 0. [:3] returns elements from the beginning up to (but not including) index 3."
    },
    {
      question: "What does list[::2] do?",
      options: [
        "Returns every element",
        "Returns every second element",
        "Returns two elements",
        "Doubles the list"
      ],
      correctAnswer: 1,
      explanation: "[::2] uses a step of 2, returning every second element (indices 0, 2, 4, ...)."
    },
    {
      question: "How do you reverse a list using slicing?",
      options: [
        "list[::-1]",
        "list[::1]",
        "list.reverse()",
        "reverse(list)"
      ],
      correctAnswer: 0,
      explanation: "[::-1] uses a step of -1, which reverses the sequence. list.reverse() also works but modifies in-place."
    }
  ],

  20: [
    {
      question: "What is exception handling?",
      options: [
        "Making exceptions",
        "Managing errors gracefully to prevent program crashes",
        "Handling special cases",
        "Exceptional programming"
      ],
      correctAnswer: 1,
      explanation: "Exception handling allows you to catch and handle errors without crashing the program."
    },
    {
      question: "Which keywords are used for exception handling in Python?",
      options: [
        "try/catch",
        "try/except",
        "catch/throw",
        "handle/error"
      ],
      correctAnswer: 1,
      explanation: "Python uses try/except blocks. The try block contains risky code, except catches errors."
    },
    {
      question: "What happens if an exception occurs in a try block?",
      options: [
        "Program crashes",
        "Control jumps to the matching except block",
        "Nothing happens",
        "The exception is ignored"
      ],
      correctAnswer: 1,
      explanation: "When an exception occurs in try, Python immediately jumps to the matching except block."
    },
    {
      question: "Can you have multiple except blocks?",
      options: [
        "No, only one except allowed",
        "Yes, to handle different exception types",
        "Only in Python 3",
        "Only with if statements"
      ],
      correctAnswer: 1,
      explanation: "You can have multiple except blocks to handle different exception types differently."
    },
    {
      question: "What is a common use case for exception handling?",
      options: [
        "Making code longer",
        "Handling user input errors, file operations, division by zero",
        "Slowing down programs",
        "Decorating functions"
      ],
      correctAnswer: 1,
      explanation: "Exception handling is essential for user input validation, file I/O, network operations, and mathematical operations."
    }
  ],

  21: [
    {
      question: "What does 'w' mode do when opening a file?",
      options: [
        "Reads the file",
        "Writes to the file (overwrites if exists)",
        "Appends to the file",
        "Creates a backup"
      ],
      correctAnswer: 1,
      explanation: "'w' mode opens for writing - creates a new file or overwrites an existing one."
    },
    {
      question: "What does 'r' mode do when opening a file?",
      options: [
        "Removes the file",
        "Opens the file for reading",
        "Rewrites the file",
        "Renames the file"
      ],
      correctAnswer: 1,
      explanation: "'r' mode (the default) opens a file for reading. Raises error if file doesn't exist."
    },
    {
      question: "What is the advantage of using 'with open()' statement?",
      options: [
        "Faster file access",
        "Automatically closes the file, even if errors occur",
        "Creates the file",
        "No advantage"
      ],
      correctAnswer: 1,
      explanation: "'with' ensures the file is properly closed after the block executes, even if an exception occurs."
    },
    {
      question: "What does 'a' mode do when opening a file?",
      options: [
        "Deletes all content",
        "Appends to the end of the file without erasing existing content",
        "Creates an archive",
        "Reads the file backwards"
      ],
      correctAnswer: 1,
      explanation: "'a' mode opens for appending - writes are added to the end, preserving existing content."
    },
    {
      question: "What method reads the entire file content as a string?",
      options: [
        "file.readline()",
        "file.read()",
        "file.readall()",
        "file.get()"
      ],
      correctAnswer: 1,
      explanation: "read() reads and returns the entire file content as a single string."
    }
  ],

  22: [
    {
      question: "What is a class in Python?",
      options: [
        "A type of function",
        "A blueprint for creating objects with attributes and methods",
        "A built-in data type",
        "A module"
      ],
      correctAnswer: 1,
      explanation: "A class is a blueprint that defines attributes (data) and methods (functions) for objects."
    },
    {
      question: "What is the purpose of the __init__ method?",
      options: [
        "To delete objects",
        "To initialize an object's attributes when it's created (constructor)",
        "To print objects",
        "To compare objects"
      ],
      correctAnswer: 1,
      explanation: "__init__ is the constructor method - it initializes an object's attributes when the object is created."
    },
    {
      question: "What is 'self' in a class method?",
      options: [
        "A keyword for recursion",
        "A reference to the current instance of the class",
        "A global variable",
        "A string"
      ],
      correctAnswer: 1,
      explanation: "'self' refers to the instance of the class - it allows you to access the object's attributes and methods."
    },
    {
      question: "What is an object in OOP?",
      options: [
        "A class definition",
        "An instance of a class with its own data",
        "A function",
        "A variable type"
      ],
      correctAnswer: 1,
      explanation: "An object is an instance of a class - a concrete realization with its own attribute values."
    },
    {
      question: "How do you create an object from a class?",
      options: [
        "new ClassName()",
        "ClassName()",
        "create ClassName",
        "object.ClassName()"
      ],
      correctAnswer: 1,
      explanation: "Call the class like a function: object = ClassName(arguments) to create an instance."
    }
  ],

  23: [
    {
      question: "What is inheritance in OOP?",
      options: [
        "Copying code",
        "A mechanism where a class inherits attributes and methods from another class",
        "Deleting classes",
        "A type of loop"
      ],
      correctAnswer: 1,
      explanation: "Inheritance allows a subclass to inherit and extend/override behavior from a parent class."
    },
    {
      question: "How do you create a subclass in Python?",
      options: [
        "class Subclass extends Parent:",
        "class Subclass(Parent):",
        "class Subclass inherits Parent:",
        "class Subclass -> Parent:"
      ],
      correctAnswer: 1,
      explanation: "Use class Subclass(Parent): to create a subclass that inherits from Parent."
    },
    {
      question: "What is method overriding?",
      options: [
        "Deleting methods",
        "A subclass providing its own implementation of a parent class method",
        "Creating new methods",
        "Calling methods twice"
      ],
      correctAnswer: 1,
      explanation: "Method overriding allows a subclass to provide a specific implementation of a method already defined in the parent."
    },
    {
      question: "Can a subclass access parent class methods?",
      options: [
        "No, subclasses are completely separate",
        "Yes, subclasses inherit parent methods unless overridden",
        "Only with special syntax",
        "Only in Python 2"
      ],
      correctAnswer: 1,
      explanation: "Subclasses automatically inherit all parent methods and can use them unless they override them."
    },
    {
      question: "What does super() do?",
      options: [
        "Makes a class more powerful",
        "Allows you to call parent class methods from a subclass",
        "Creates a new class",
        "Deletes the parent class"
      ],
      correctAnswer: 1,
      explanation: "super() gives you access to the parent class, often used to call parent's __init__ or overridden methods."
    }
  ],

  24: [
    {
      question: "What is a lambda function?",
      options: [
        "A named function",
        "A small anonymous function defined with lambda keyword",
        "A class method",
        "A loop type"
      ],
      correctAnswer: 1,
      explanation: "Lambda creates small anonymous functions in a single line: lambda parameters: expression."
    },
    {
      question: "What is the syntax for a lambda function?",
      options: [
        "function(x): x * 2",
        "lambda x: x * 2",
        "def lambda(x): x * 2",
        "lambda: x * 2"
      ],
      correctAnswer: 1,
      explanation: "Syntax is: lambda parameters: expression. Example: lambda x: x * 2 creates a function that doubles x."
    },
    {
      question: "Can lambda functions have multiple expressions?",
      options: [
        "Yes, unlimited",
        "No, only a single expression",
        "Only two expressions",
        "Only with semicolons"
      ],
      correctAnswer: 1,
      explanation: "Lambda functions are limited to a single expression (though it can be complex)."
    },
    {
      question: "Where are lambda functions commonly used?",
      options: [
        "As main program functions",
        "With functions like map(), filter(), sorted() that need simple functions",
        "For class definitions",
        "For loops"
      ],
      correctAnswer: 1,
      explanation: "Lambdas are often used as short-lived functions passed to map(), filter(), sorted(), etc."
    },
    {
      question: "What does lambda x, y: x + y do?",
      options: [
        "Subtracts y from x",
        "Creates a function that adds two numbers",
        "Multiplies x and y",
        "Creates an error"
      ],
      correctAnswer: 1,
      explanation: "This lambda takes two parameters and returns their sum - equivalent to: def add(x, y): return x + y."
    }
  ],

  25: [
    {
      question: "What does the map() function do?",
      options: [
        "Creates a dictionary",
        "Applies a function to every item in an iterable",
        "Navigates a list",
        "Sorts items"
      ],
      correctAnswer: 1,
      explanation: "map(function, iterable) applies the function to each item and returns a map object (convert to list to see results)."
    },
    {
      question: "What does filter() return?",
      options: [
        "All items",
        "Items for which the function returns True",
        "The first matching item",
        "A dictionary"
      ],
      correctAnswer: 1,
      explanation: "filter(function, iterable) returns only items where function(item) is True."
    },
    {
      question: "How do you convert a map object to a list?",
      options: [
        "map.toList()",
        "list(map_object)",
        "convert(map_object)",
        "array(map_object)"
      ],
      correctAnswer: 1,
      explanation: "map() and filter() return iterators. Use list() to convert them to lists."
    },
    {
      question: "What does list(map(lambda x: x**2, [1,2,3])) produce?",
      options: [
        "[1, 2, 3]",
        "[1, 4, 9]",
        "[2, 4, 6]",
        "[1, 8, 27]"
      ],
      correctAnswer: 1,
      explanation: "This squares each number: 1²=1, 2²=4, 3²=9, resulting in [1, 4, 9]."
    },
    {
      question: "What does filter(lambda x: x > 0, [-1, 0, 1, 2]) return?",
      options: [
        "[-1, 0, 1, 2]",
        "[1, 2]",
        "[0, 1, 2]",
        "[-1]"
      ],
      correctAnswer: 1,
      explanation: "filter keeps only items where the condition is True - only 1 and 2 are greater than 0."
    }
  ],

  26: [
    {
      question: "What is recursion?",
      options: [
        "A loop type",
        "A technique where a function calls itself",
        "A way to import modules",
        "A class method"
      ],
      correctAnswer: 1,
      explanation: "Recursion is when a function calls itself to solve a problem by breaking it into smaller sub-problems."
    },
    {
      question: "What is a base case in recursion?",
      options: [
        "The first function call",
        "The condition that stops the recursion",
        "The main function",
        "The error case"
      ],
      correctAnswer: 1,
      explanation: "A base case is the condition that stops recursion - without it, you get infinite recursion."
    },
    {
      question: "What happens if a recursive function has no base case?",
      options: [
        "It works perfectly",
        "It causes infinite recursion and eventually a stack overflow error",
        "Python prevents it",
        "It returns None"
      ],
      correctAnswer: 1,
      explanation: "Without a base case, the function calls itself forever, causing a RecursionError (stack overflow)."
    },
    {
      question: "What is factorial(5)?",
      options: [
        "25",
        "120",
        "15",
        "5"
      ],
      correctAnswer: 1,
      explanation: "factorial(5) = 5 * 4 * 3 * 2 * 1 = 120."
    },
    {
      question: "When is recursion useful?",
      options: [
        "Never, always use loops",
        "For problems that can be broken down into similar sub-problems (trees, factorials, Fibonacci)",
        "Only for mathematics",
        "Only for sorting"
      ],
      correctAnswer: 1,
      explanation: "Recursion is elegant for problems with recursive structure: trees, graphs, divide-and-conquer algorithms."
    }
  ],

  27: [
    {
      question: "What does random.randint(1, 10) do?",
      options: [
        "Returns a float between 1 and 10",
        "Returns a random integer between 1 and 10 (inclusive)",
        "Returns random integers from 1 to 9",
        "Returns 1 or 10"
      ],
      correctAnswer: 1,
      explanation: "randint(a, b) returns a random integer N where a <= N <= b (both endpoints included)."
    },
    {
      question: "What is the difference between randint() and random()?",
      options: [
        "No difference",
        "randint() returns an integer; random() returns a float between 0.0 and 1.0",
        "random() is faster",
        "randint() is deprecated"
      ],
      correctAnswer: 1,
      explanation: "random.randint(a,b) returns integers. random.random() returns a float in [0.0, 1.0)."
    },
    {
      question: "What does random.choice([1, 2, 3, 4]) do?",
      options: [
        "Sorts the list",
        "Returns a randomly selected element from the list",
        "Returns all elements",
        "Returns the first element"
      ],
      correctAnswer: 1,
      explanation: "choice() randomly selects and returns one element from a non-empty sequence."
    },
    {
      question: "Do you need to import random before using it?",
      options: [
        "No, it's built-in",
        "Yes, use 'import random'",
        "Only in Python 2",
        "Only for randint"
      ],
      correctAnswer: 1,
      explanation: "random is a standard library module that must be imported: import random."
    },
    {
      question: "What does random.shuffle() do?",
      options: [
        "Creates a new shuffled list",
        "Randomly reorders a list in-place",
        "Picks a random element",
        "Sorts the list"
      ],
      correctAnswer: 1,
      explanation: "shuffle() modifies a list in-place, randomly reordering its elements."
    }
  ],

  28: [
    {
      question: "What is the purpose of a loop counter in a guessing game?",
      options: [
        "To count guesses",
        "To limit the number of attempts and end the game after a maximum",
        "To generate random numbers",
        "To display the score"
      ],
      correctAnswer: 1,
      explanation: "A counter tracks attempts and helps implement a maximum limit to end the game."
    },
    {
      question: "How do you give hints in a number guessing game?",
      options: [
        "Show the answer",
        "Use conditionals to compare guess with target and print 'higher' or 'lower'",
        "Don't give hints",
        "Use random numbers"
      ],
      correctAnswer: 1,
      explanation: "Compare the guess with the secret number and print whether the guess should be higher or lower."
    },
    {
      question: "Why use a while loop for a guessing game?",
      options: [
        "It's faster",
        "It continues until the condition is met (correct guess or max attempts)",
        "For loops don't work",
        "To make it harder"
      ],
      correctAnswer: 1,
      explanation: "A while loop continues as long as the player hasn't guessed correctly and hasn't run out of attempts."
    },
    {
      question: "What happens when the player exceeds maximum attempts?",
      options: [
        "Game continues forever",
        "Display a 'game over' message and exit the loop",
        "Restart automatically",
        "Crash the program"
      ],
      correctAnswer: 1,
      explanation: "When attempts run out, display a game over message, optionally reveal the answer, and exit."
    },
    {
      question: "What skills does building a guessing game practice?",
      options: [
        "Only random numbers",
        "Loops, conditionals, input, random numbers, and user feedback",
        "Only input/output",
        "Only variables"
      ],
      correctAnswer: 1,
      explanation: "A guessing game combines many fundamental concepts: loops, conditions, I/O, random, counters, and logic."
    }
  ],

  29: [
    {
      question: "What data structure is best for a todo list?",
      options: [
        "Dictionary",
        "List",
        "Set",
        "Tuple"
      ],
      correctAnswer: 1,
      explanation: "A list is ideal for todo items - it's ordered, mutable, and supports easy adding/removing of tasks."
    },
    {
      question: "How do you add a new todo item to the list?",
      options: [
        "list.insert(item)",
        "list.append(item)",
        "list.add(item)",
        "list += item"
      ],
      correctAnswer: 1,
      explanation: "append() adds an item to the end of a list - perfect for adding new todo items."
    },
    {
      question: "How would you remove a completed task from a todo list?",
      options: [
        "list.delete(item)",
        "list.remove(item) or del list[index]",
        "list.clear()",
        "list.pop_all()"
      ],
      correctAnswer: 1,
      explanation: "Use remove(item) to remove by value, or del list[index] or pop(index) to remove by position."
    },
    {
      question: "What loop is appropriate for continuously adding tasks?",
      options: [
        "for loop with range",
        "while loop with a condition to exit (e.g., user types 'quit')",
        "No loop needed",
        "Nested loops"
      ],
      correctAnswer: 1,
      explanation: "A while loop allows continuous input until the user decides to quit."
    },
    {
      question: "What programming concepts does a todo list application practice?",
      options: [
        "Only lists",
        "Lists, loops, input, conditionals, and possibly functions",
        "Only input/output",
        "Only strings"
      ],
      correctAnswer: 1,
      explanation: "A todo app combines lists, loops for menu/input, conditionals for commands, and functions for organization."
    }
  ],

  30: [
    {
      question: "In Rock-Paper-Scissors, what data structure holds the choices?",
      options: [
        "Dictionary",
        "List of strings: ['rock', 'paper', 'scissors']",
        "Set",
        "Tuple of numbers"
      ],
      correctAnswer: 1,
      explanation: "A list (or tuple) of strings is perfect for storing and randomly selecting from game choices."
    },
    {
      question: "How do you make the computer choose randomly?",
      options: [
        "Always pick 'rock'",
        "Use random.choice(choices)",
        "User decides",
        "Pick the first element"
      ],
      correctAnswer: 1,
      explanation: "random.choice(choices) randomly selects one element from the choices list."
    },
    {
      question: "How do you determine the winner in Rock-Paper-Scissors?",
      options: [
        "Use random",
        "Use nested if/elif statements comparing player and computer choices",
        "Always let player win",
        "Use a loop"
      ],
      correctAnswer: 1,
      explanation: "Use conditional logic: rock beats scissors, scissors beats paper, paper beats rock. Check all combinations."
    },
    {
      question: "What skills does building Rock-Paper-Scissors practice?",
      options: [
        "Only conditionals",
        "Loops, conditionals, random, input, string comparison, game logic",
        "Only random numbers",
        "Only lists"
      ],
      correctAnswer: 1,
      explanation: "This game combines many concepts: loops (play again), conditionals (winner logic), random, input, and more."
    },
    {
      question: "How do you implement 'play again' functionality?",
      options: [
        "Restart the program",
        "Use a while loop that continues until user chooses to quit",
        "Recursion only",
        "Not possible"
      ],
      correctAnswer: 1,
      explanation: "A while loop that asks 'play again?' after each round is the standard approach."
    }
  ],

  31: [
    {
      question: "What prefix is used for binary numbers in Python?",
      options: [
        "0x",
        "0b",
        "0o",
        "0d"
      ],
      correctAnswer: 1,
      explanation: "Binary numbers use the 0b prefix. Example: 0b1010 represents 10 in decimal."
    },
    {
      question: "What is 0xFF in decimal?",
      options: [
        "15",
        "255",
        "16",
        "256"
      ],
      correctAnswer: 1,
      explanation: "0xFF is hexadecimal for 255 in decimal (15 * 16 + 15 = 255)."
    },
    {
      question: "What does bin(10) return?",
      options: [
        "'10'",
        "'0b1010'",
        "1010",
        "'1010'"
      ],
      correctAnswer: 1,
      explanation: "bin() converts a number to its binary string representation with '0b' prefix."
    },
    {
      question: "Which function converts a hexadecimal string to an integer?",
      options: [
        "hex()",
        "int('FF', 16)",
        "convert('FF')",
        "hexadecimal('FF')"
      ],
      correctAnswer: 1,
      explanation: "int(string, base) converts a string in the given base to decimal. int('FF', 16) = 255."
    },
    {
      question: "What is octal 0o77 in decimal?",
      options: [
        "77",
        "63",
        "56",
        "49"
      ],
      correctAnswer: 1,
      explanation: "Octal 77 = 7*8 + 7 = 63 in decimal. The 0o prefix denotes octal."
    }
  ],

  32: [
    {
      question: "What does the & operator do in bitwise operations?",
      options: [
        "Bitwise OR",
        "Bitwise AND - returns 1 only if both bits are 1",
        "Bitwise XOR",
        "Bitwise NOT"
      ],
      correctAnswer: 1,
      explanation: "& performs bitwise AND: compares each bit, returns 1 only when both bits are 1."
    },
    {
      question: "What is 12 & 10 in binary operations?",
      options: [
        "14",
        "8",
        "2",
        "22"
      ],
      correctAnswer: 1,
      explanation: "12 (1100) & 10 (1010) = 1000 = 8. AND compares each bit position."
    },
    {
      question: "What does the | operator do?",
      options: [
        "Division",
        "Bitwise OR - returns 1 if either bit is 1",
        "Comparison",
        "String concatenation"
      ],
      correctAnswer: 1,
      explanation: "| performs bitwise OR: returns 1 if either or both bits are 1."
    },
    {
      question: "What is 5 << 2?",
      options: [
        "7",
        "20",
        "10",
        "25"
      ],
      correctAnswer: 1,
      explanation: "<< is left shift. 5 (101 in binary) shifted left 2 positions = 10100 = 20. Equivalent to 5 * 2^2."
    },
    {
      question: "What does the ^ operator do?",
      options: [
        "Exponentiation",
        "Bitwise XOR - returns 1 if bits are different",
        "Comparison",
        "Floor division"
      ],
      correctAnswer: 1,
      explanation: "^ performs XOR (exclusive OR): returns 1 when bits are different, 0 when same."
    }
  ],

  33: [
    {
      question: "Which operator has the highest precedence?",
      options: [
        "+",
        "**",
        "*",
        "=="
      ],
      correctAnswer: 1,
      explanation: "** (exponentiation) has the highest precedence among arithmetic operators."
    },
    {
      question: "What does x += 5 mean?",
      options: [
        "x = x + 5",
        "x = 5",
        "x == x + 5",
        "x = x - 5"
      ],
      correctAnswer: 0,
      explanation: "+= is augmented assignment: x += 5 is shorthand for x = x + 5."
    },
    {
      question: "What is the result of 2 + 3 * 4?",
      options: [
        "20",
        "14",
        "24",
        "12"
      ],
      correctAnswer: 1,
      explanation: "Multiplication has higher precedence than addition: 3 * 4 = 12, then 2 + 12 = 14."
    },
    {
      question: "Which of these augmented assignment operators exists in Python?",
      options: [
        "**=",
        "++",
        "--",
        "=+"
      ],
      correctAnswer: 0,
      explanation: "**= is valid (x **= 2 means x = x ** 2). Python doesn't have ++ or -- operators."
    },
    {
      question: "What is evaluated first in: 10 + 5 * 2 ** 3?",
      options: [
        "10 + 5",
        "2 ** 3",
        "5 * 2",
        "All at once"
      ],
      correctAnswer: 1,
      explanation: "Order: exponentiation (2**3=8), then multiplication (5*8=40), then addition (10+40=50)."
    }
  ],

  34: [
    {
      question: "What is the LEGB rule in Python?",
      options: [
        "A naming convention",
        "The order Python searches for variables: Local, Enclosing, Global, Built-in",
        "A loop type",
        "An error handling rule"
      ],
      correctAnswer: 1,
      explanation: "LEGB defines variable lookup order: Local (function) → Enclosing (outer functions) → Global (module) → Built-in."
    },
    {
      question: "What does the 'global' keyword do?",
      options: [
        "Creates a new variable",
        "Allows a function to modify a global variable",
        "Deletes a variable",
        "Makes a variable private"
      ],
      correctAnswer: 1,
      explanation: "global declares that a variable inside a function refers to the global scope variable."
    },
    {
      question: "Can a nested function access variables from its enclosing function?",
      options: [
        "No, never",
        "Yes, read-only by default; use 'nonlocal' to modify",
        "Only with 'global'",
        "Only in Python 2"
      ],
      correctAnswer: 1,
      explanation: "Nested functions can read enclosing scope variables. Use 'nonlocal' to modify them."
    },
    {
      question: "What happens if you assign to a variable inside a function without 'global'?",
      options: [
        "Error",
        "Creates a new local variable, shadows global",
        "Modifies the global variable",
        "Deletes the variable"
      ],
      correctAnswer: 1,
      explanation: "Assignment creates a new local variable that shadows any global variable with the same name."
    },
    {
      question: "When would you use the 'nonlocal' keyword?",
      options: [
        "To access built-in functions",
        "To modify a variable from an enclosing (not global) scope in a nested function",
        "To create global variables",
        "To import modules"
      ],
      correctAnswer: 1,
      explanation: "nonlocal allows nested functions to modify variables from their enclosing function scope."
    }
  ],

  35: [
    {
      question: "What do default parameters allow?",
      options: [
        "Calling functions without parentheses",
        "Calling functions without providing all arguments",
        "Creating multiple functions",
        "Deleting parameters"
      ],
      correctAnswer: 1,
      explanation: "Default parameters provide fallback values, allowing calls with fewer arguments than defined."
    },
    {
      question: "What does *args do in a function definition?",
      options: [
        "Multiplies arguments",
        "Collects extra positional arguments into a tuple",
        "Creates an error",
        "Makes arguments optional"
      ],
      correctAnswer: 1,
      explanation: "*args collects any number of positional arguments into a tuple accessible inside the function."
    },
    {
      question: "What does **kwargs do?",
      options: [
        "Raises arguments to a power",
        "Collects extra keyword arguments into a dictionary",
        "Repeats arguments",
        "Compares arguments"
      ],
      correctAnswer: 1,
      explanation: "**kwargs collects keyword arguments as a dictionary with argument names as keys."
    },
    {
      question: "What is the correct order for parameters?",
      options: [
        "**kwargs, *args, regular, default",
        "regular, default, *args, **kwargs",
        "default, regular, *args, **kwargs",
        "Any order"
      ],
      correctAnswer: 1,
      explanation: "Order must be: regular parameters, default parameters, *args, **kwargs."
    },
    {
      question: "Can you have a default parameter before a non-default one?",
      options: [
        "Yes, always allowed",
        "No, default parameters must come after non-default",
        "Only in Python 3",
        "Only with *args"
      ],
      correctAnswer: 1,
      explanation: "SyntaxError: non-default parameters cannot follow default parameters in the definition."
    }
  ],

  36: [
    {
      question: "What is the base class of all exceptions in Python?",
      options: [
        "Exception",
        "BaseException",
        "Error",
        "StandardError"
      ],
      correctAnswer: 1,
      explanation: "BaseException is the root of the exception hierarchy. Exception inherits from BaseException."
    },
    {
      question: "Which exception is raised when dividing by zero?",
      options: [
        "DivisionError",
        "ZeroDivisionError",
        "ArithmeticError",
        "ValueError"
      ],
      correctAnswer: 1,
      explanation: "ZeroDivisionError is raised specifically for division or modulo by zero."
    },
    {
      question: "What's the correct order for except blocks?",
      options: [
        "Any order is fine",
        "Specific exceptions before general ones",
        "General before specific",
        "Alphabetical order"
      ],
      correctAnswer: 1,
      explanation: "Catch specific exceptions first, then more general ones. Otherwise, general catches prevent specific."
    },
    {
      question: "Which exception is raised for invalid type operations?",
      options: [
        "ValueError",
        "TypeError",
        "AttributeError",
        "SyntaxError"
      ],
      correctAnswer: 1,
      explanation: "TypeError is raised when an operation is applied to an inappropriate type."
    },
    {
      question: "What does the 'finally' block do?",
      options: [
        "Catches all exceptions",
        "Executes regardless of whether an exception occurred",
        "Ends the program",
        "Raises an exception"
      ],
      correctAnswer: 1,
      explanation: "finally always executes, whether an exception occurred or not - useful for cleanup."
    }
  ],

  37: [
    {
      question: "What does \\n represent in a string?",
      options: [
        "A literal backslash and n",
        "A newline character",
        "Nothing",
        "An error"
      ],
      correctAnswer: 1,
      explanation: "\\n is an escape sequence representing a newline (line break)."
    },
    {
      question: "How do you include a backslash in a string?",
      options: [
        "Use \\",
        "Use \\\\",
        "Use /",
        "Impossible"
      ],
      correctAnswer: 1,
      explanation: "Use \\\\ to represent a single backslash, since \\ is the escape character."
    },
    {
      question: "What are raw strings (r'...')?",
      options: [
        "Unprocessed input",
        "Strings where escape sequences are treated as literal characters",
        "Binary strings",
        "Empty strings"
      ],
      correctAnswer: 1,
      explanation: "Raw strings (r'...') treat backslashes as literal characters, not escape sequences."
    },
    {
      question: "What does '\\t' represent?",
      options: [
        "The letter t",
        "A tab character",
        "Time",
        "Template"
      ],
      correctAnswer: 1,
      explanation: "\\t is the escape sequence for a tab character (horizontal spacing)."
    },
    {
      question: "How do you create a multi-line string?",
      options: [
        "Use single quotes only",
        "Use triple quotes: '''...''' or \"\"\"...\"\"\"",
        "Use \\n everywhere",
        "Not possible"
      ],
      correctAnswer: 1,
      explanation: "Triple quotes create multi-line strings that preserve line breaks and formatting."
    }
  ],

  38: [
    {
      question: "What's the difference between .append() and .extend()?",
      options: [
        "No difference",
        "append() adds one item; extend() adds multiple items from an iterable",
        "extend() is faster",
        "append() is deprecated"
      ],
      correctAnswer: 1,
      explanation: "append() adds a single element; extend() adds all elements from an iterable to the list."
    },
    {
      question: "What does dict.get(key, default) do?",
      options: [
        "Always raises KeyError",
        "Returns dict[key] if exists, otherwise returns default value",
        "Deletes the key",
        "Creates a new key"
      ],
      correctAnswer: 1,
      explanation: ".get() safely accesses dictionary values, returning a default if the key doesn't exist."
    },
    {
      question: "What is tuple unpacking?",
      options: [
        "Deleting tuples",
        "Assigning tuple elements to multiple variables: a, b = (1, 2)",
        "Converting to list",
        "Sorting tuples"
      ],
      correctAnswer: 1,
      explanation: "Tuple unpacking assigns each element to a corresponding variable: a, b = (1, 2)."
    },
    {
      question: "What's the difference between sort() and sorted()?",
      options: [
        "No difference",
        "sort() modifies in-place; sorted() returns a new sorted list",
        "sorted() is slower",
        "sort() is deprecated"
      ],
      correctAnswer: 1,
      explanation: ".sort() modifies the list in-place. sorted() returns a new sorted list without changing the original."
    },
    {
      question: "What is a dictionary comprehension?",
      options: [
        "A way to read dictionaries",
        "A concise way to create dictionaries: {k: v for k, v in items}",
        "A dictionary method",
        "An error type"
      ],
      correctAnswer: 1,
      explanation: "Dictionary comprehensions create dictionaries using concise syntax: {key: value for item in iterable}."
    }
  ],

  39: [
    {
      question: "Is Python compiled or interpreted?",
      options: [
        "Only compiled",
        "Interpreted (compiled to bytecode, then interpreted)",
        "Only interpreted",
        "Neither"
      ],
      correctAnswer: 1,
      explanation: "Python is compiled to bytecode (.pyc files), then the bytecode is interpreted by the Python VM."
    },
    {
      question: "What is PEP-8?",
      options: [
        "A Python version",
        "Python's official style guide for code formatting",
        "An error type",
        "A module"
      ],
      correctAnswer: 1,
      explanation: "PEP-8 is the Python Enhancement Proposal that defines coding style conventions."
    },
    {
      question: "What does PEP-8 recommend for indentation?",
      options: [
        "2 spaces",
        "4 spaces",
        "Tabs only",
        "8 spaces"
      ],
      correctAnswer: 1,
      explanation: "PEP-8 recommends 4 spaces per indentation level (not tabs)."
    },
    {
      question: "What naming convention does PEP-8 recommend for functions?",
      options: [
        "camelCase",
        "snake_case (lowercase with underscores)",
        "PascalCase",
        "UPPERCASE"
      ],
      correctAnswer: 1,
      explanation: "PEP-8 recommends snake_case for function and variable names: my_function()."
    },
    {
      question: "What is the recommended maximum line length in PEP-8?",
      options: [
        "No limit",
        "79 characters",
        "120 characters",
        "100 characters"
      ],
      correctAnswer: 1,
      explanation: "PEP-8 recommends limiting lines to 79 characters for better readability."
    }
  ],

  40: [
    {
      question: "Which of these is NOT a valid Python data type?",
      options: [
        "int",
        "char",
        "str",
        "bool"
      ],
      correctAnswer: 1,
      explanation: "Python doesn't have a 'char' type - single characters are strings of length 1."
    },
    {
      question: "What does the PCEP certification test?",
      options: [
        "Advanced Python",
        "Entry-level Python programming skills and fundamental concepts",
        "Only web development",
        "Only data science"
      ],
      correctAnswer: 1,
      explanation: "PCEP tests fundamental Python knowledge: syntax, data types, control flow, functions, exceptions, and OOP basics."
    },
    {
      question: "Which statement best describes Python's philosophy?",
      options: [
        "Complex is better than simple",
        "Simple is better than complex; readability counts",
        "Speed over clarity",
        "More code is better"
      ],
      correctAnswer: 1,
      explanation: "The Zen of Python emphasizes simplicity, readability, and clarity over complexity."
    },
    {
      question: "What are the four main blocks of the PCEP syllabus?",
      options: [
        "Web, Data, ML, AI",
        "Computer Programming Basics, Data Types, Control Flow, Data Collections & Functions",
        "Syntax, Loops, Classes, Modules",
        "Variables, Files, Networks, Databases"
      ],
      correctAnswer: 1,
      explanation: "PCEP covers: (1) Programming Basics (18%), (2) Data Types (29%), (3) Control Flow (25%), (4) Collections & Functions (28%)."
    },
    {
      question: "What score do you need to pass the PCEP exam?",
      options: [
        "50%",
        "70%",
        "80%",
        "90%"
      ],
      correctAnswer: 1,
      explanation: "You need 70% (28/40 questions) to pass the PCEP certification exam."
    }
  ]
};

// Function to get questions for a level
export function getQuizForLevel(levelId) {
  return quizQuestions[levelId] || [];
}
